import { IErrorResponseSchema } from '../../repositories/chats/entities/schemas/ErrorResponseSchema';
import { IModalWarningSchema } from '../../repositories/chats/entities/spam_modal_warning/ModalWarningSchema';
import { ISyncChatSchema } from '../../repositories/chats/entities/synchronization/SyncChatSchema';
import { TSingleChatV2Response } from '../../types/chatList';
import { EFirstMessageStatus } from '../../types/firstMessageStatus';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { TAppTelemetryLogger } from '../../types/telemetry';

export const Messages = {
  [EFirstMessageStatus.ChatsBlocked]: 'Чаты заблокированы',
  [EFirstMessageStatus.ChatsDisabled]: 'Чаты отключены',
  [EFirstMessageStatus.NeedConfirmPhone]: 'Необходимо подтвердить телефон',
  [EFirstMessageStatus.UserCanNotChatWithHimself]: 'Нет возможности создать чат с самим собой',
};

export enum EFirstMessageActionTypes {
  Pending = 'firstMessage/pending',
  Sent = 'firstMessage/sent',
  Failed = 'firstMessage/failed',
  ChatsBlocked = 'firstMessage/chatsBlocked',
  NeedCaptcha = 'firstMessage/needCaptcha',
  NeedConfirmPhone = 'firstMessage/needConfirmPhone',
  UserChatsDisabled = 'firstMessage/userChatsDisabled',
  ValidationError = 'firstMessage/validationError',
}

export interface IFirstMessageSentPayload {
  chat: TSingleChatV2Response;
}

type TFirstMessagePending = ITypedReduxAction<EFirstMessageActionTypes.Pending>;
type TFirstMessageSent = ITypedReduxAction<EFirstMessageActionTypes.Sent, IFirstMessageSentPayload>;
type TFirstMessageFailed = ITypedReduxAction<EFirstMessageActionTypes.Failed>;
type TFirstMessageChatsBlocked = ITypedReduxAction<EFirstMessageActionTypes.ChatsBlocked>;
type TFirstMessageNeedCaptcha = ITypedReduxAction<EFirstMessageActionTypes.NeedCaptcha>;
type TFirstMessageNeedConfirmPhone = ITypedReduxAction<EFirstMessageActionTypes.NeedConfirmPhone>;
type TFirstMessageUserChatsDisabled = ITypedReduxAction<EFirstMessageActionTypes.UserChatsDisabled>;
type TFirstMessageValidationError = ITypedReduxAction<EFirstMessageActionTypes.ValidationError>;

export type TFirstMessageActions =
  | TFirstMessagePending
  | TFirstMessageSent
  | TFirstMessageFailed
  | TFirstMessageChatsBlocked
  | TFirstMessageNeedCaptcha
  | TFirstMessageNeedConfirmPhone
  | TFirstMessageUserChatsDisabled
  | TFirstMessageValidationError;

export enum EFirstMessageResponseStatus {
  Success = 'success',
  Blocked = 'blocked',
  ForbiddenText = 'forbiddenText',
  NeedCaptcha = 'needCaptcha',
  NeedConfirmPhone = 'needConfirmPhone',
  UserChatsDisabled = 'userChatsDisabled',
  ValidationError = 'validationError',
  UnknownError = 'unknownError',
}

type TResponseTemplate<S extends EFirstMessageResponseStatus, T = void> = T extends void
  ? { status: S }
  : { status: S; data: T };

export type TFirstMessageResponse =
  | TResponseTemplate<EFirstMessageResponseStatus.Success, ISyncChatSchema>
  | TResponseTemplate<EFirstMessageResponseStatus.Blocked>
  | TResponseTemplate<EFirstMessageResponseStatus.ForbiddenText, IModalWarningSchema>
  | TResponseTemplate<EFirstMessageResponseStatus.NeedCaptcha>
  | TResponseTemplate<EFirstMessageResponseStatus.NeedConfirmPhone>
  | TResponseTemplate<EFirstMessageResponseStatus.UserChatsDisabled>
  | TResponseTemplate<EFirstMessageResponseStatus.ValidationError, IErrorResponseSchema>
  | TResponseTemplate<EFirstMessageResponseStatus.UnknownError, IErrorResponseSchema>;

export interface IAssertDependencies {
  /** Время начала отправки первого сообщения. Нужно для телеметрии timing */
  startTime: number;
  /** Флаг отключения аналитики ключа */
  isAnalyticsKeyDisabled?: boolean;
  /** Текст сообщения */
  text: string;
  /** Домен для ошибки */
  domain: string;
  /**
   * Телеметрия для отслеживания событий при отправке первого сообщения.
   * Для каждой ручки первого сообщения используется своя абстракция над телеметрией, нужно использовать ее вместо дефолтной из thunk-контекста.
   * Кастомная телеметрия добавляет ключ источника к событию.
   */
  telemetry: TAppTelemetryLogger;
}
